(function () {
  "use strict";

  var pending = null;
  var approvedOrder = {
    "Available in store": 0,
    Fit: 1,
    Category: 2,
    Size: 3,
    Color: 4,
    Brand: 5,
    "Sleeve Length": 6,
    Fabric: 7,
    Age: 8,
    "Closure Type": 9,
    Sale: 10,
  };

  function cleanLabel(value) {
    return String(value || "")
      .replace(/\s*\([\d,]+\)\s*$/, "")
      .trim();
  }

  function canonicalFacet(value) {
    var label = cleanLabel(value).toLowerCase();

    if (label === "cq fit" || label === "fit") return "Fit";
    if (
      label === "cq shopping category" ||
      label === "shopping category" ||
      label === "category"
    ) {
      return "Category";
    }
    if (
      label === "cq normalized size" ||
      label === "normalized size" ||
      label === "size"
    ) {
      return "Size";
    }
    if (
      label === "cq color family" ||
      label === "color family" ||
      label === "color"
    ) {
      return "Color";
    }
    if (label === "vendor" || label === "brand") return "Brand";
    if (label === "cq sleeve length" || label === "sleeve length") {
      return "Sleeve Length";
    }
    if (
      label === "cq fabric family" ||
      label === "fabric family" ||
      label === "fabric"
    ) {
      return "Fabric";
    }
    if (
      label === "cq age group" ||
      label === "age group" ||
      label === "age"
    ) {
      return "Age";
    }
    if (label === "cq closure type" || label === "closure type") {
      return "Closure Type";
    }
    if (label === "sale" || label === "on sale") return "Sale";
    if (
      label === "available in store" ||
      label === "cq available in store"
    ) {
      return "Available in store";
    }

    return null;
  }

  function hideInvalidKidsAgeValue(facet, facetName) {
    if (
      facetName !== "Age" ||
      !/^\/collections\/kids(?:\/|$)/.test(window.location.pathname)
    ) {
      return;
    }

    facet
      .querySelectorAll('input[type="checkbox"], input[type="radio"]')
      .forEach(function (input) {
        var label = input.id
          ? facet.querySelector('label[for="' + CSS.escape(input.id) + '"]')
          : null;
        var value = cleanLabel(
          (label && label.textContent) ||
            input.getAttribute("data-label") ||
            input.getAttribute("aria-label") ||
            input.value,
        );

        if (value.toLowerCase() === "adult") {
          var row = input.closest("li") || input.closest("label");
          if (row) {
            row.hidden = true;
            row.setAttribute("aria-hidden", "true");
          }
        }
      });
  }

  function repairMissingTranslations() {
    document
      .querySelectorAll(
        '[aria-label="Translation missing: en.general.search.search"]',
      )
      .forEach(function (element) {
        element.setAttribute("aria-label", "Search");
      });

    document
      .querySelectorAll(".add-to-cart-text--added")
      .forEach(function (element) {
        if (
          element.textContent.trim() ===
          "Translation missing: en.products.product.added"
        ) {
          element.textContent = "Added";
        }
      });
  }

  function enhanceFacets() {
    repairMissingTranslations();

    document
      .querySelectorAll(
        "accordion-custom.facets__item[data-filter-param-name]",
      )
      .forEach(function (facet) {
        var labelNode = facet.querySelector(".facets__label");
        var facetName = labelNode
          ? canonicalFacet(labelNode.textContent)
          : null;

        if (!facetName) return;

        if (labelNode.textContent.trim() !== facetName) {
          labelNode.textContent = facetName;
        }
        facet.dataset.cqFacet = facetName;
        hideInvalidKidsAgeValue(facet, facetName);
      });

    document
      .querySelectorAll(".facets__filters-wrapper")
      .forEach(function (wrapper) {
        var current = Array.prototype.slice.call(wrapper.children);
        var desired = current.slice().sort(function (a, b) {
            var aOrder = Object.prototype.hasOwnProperty.call(
              approvedOrder,
              a.dataset.cqFacet,
            )
              ? approvedOrder[a.dataset.cqFacet]
              : 999;
            var bOrder = Object.prototype.hasOwnProperty.call(
              approvedOrder,
              b.dataset.cqFacet,
            )
              ? approvedOrder[b.dataset.cqFacet]
              : 999;
            return aOrder - bOrder;
          });
        var changed = desired.some(function (child, index) {
          return child !== current[index];
        });

        if (changed) {
          desired.forEach(function (child) {
            wrapper.appendChild(child);
          });
        }
      });
  }

  function schedule() {
    window.clearTimeout(pending);
    pending = window.setTimeout(enhanceFacets, 60);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enhanceFacets, {
      once: true,
    });
  } else {
    enhanceFacets();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
